import { render, staticRenderFns } from "./DefinitionList.vue?vue&type=template&id=00c82ef8&scoped=true&"
import script from "./DefinitionList.vue?vue&type=script&lang=js&"
export * from "./DefinitionList.vue?vue&type=script&lang=js&"
import style0 from "./DefinitionList.vue?vue&type=style&index=0&id=00c82ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c82ef8",
  null
  
)

export default component.exports